import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import './Home.css';

const Home = () => {
  return (
    <>
      <Helmet>
          <title>Our Project | GEMCO</title>
          <meta name="description" content="Discover 150+ major MEP projects successfully delivered across the UAE since 1996, showcasing Gemco’s expertise in commercial, hospitality, healthcare, and industrial developments." />
          <meta name="keywords" content="MEP projects UAE, completed MEP projects, UAE construction projects, commercial MEP works, hospitality MEP projects, healthcare MEP solutions, industrial MEP projects, Dubai MEP contractor, large scale MEP projects, Gemco projects UAE, MEP engineering company UAE" />
      </Helmet>
    <div className='wp_project_home_wrap'>
        <div className="container wp_project_home_content">
            <h1>Our Projects</h1>
            <p>150+ major MEP projects delivered across the UAE since 1996.</p>
        </div>
    </div>
    </>
  )
}

export default Home